<template>
  <egg-label-list
    title="aboutus.ourValues"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconDeepBlue', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', position: 'top:50%' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="aboutusStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useAboutUsStore } from "@/stores/aboutus";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const aboutusStore = useAboutUsStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>